export { default } from "./OrderListInBasket-container";
